import React from 'react';
import { motion } from 'framer-motion';
import { Target, Eye, Heart } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Target,
      title: 'Missão',
      description: 'Oferecer serviços contábeis e consultoria tributária com clareza, proximidade e segurança, ajudando empresas a crescer com organização, conformidade e economia fiscal.',
      color: '#0a4b3c'
    },
    {
      icon: Eye,
      title: 'Visão',
      description: 'Ser reconhecida como uma contabilidade moderna, consultiva e acessível, que transforma a gestão das pequenas e médias empresas por meio de atendimento humano, agilidade e soluções inteligentes',
      color: '#2a6b5c'
    },
    {
      icon: Heart,
      title: 'Valores',
      description: 'Respeito; Constante aperfeiçoamento; Compromisso com o cliente; Profissionalismo; União e parceria',
      color: '#0a4b3c'
    }
  ];

  return (
    <section id="about" className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img
              alt="Logotipo TALC Assessoria Contábil"
              className="rounded-2xl shadow-xl w-full h-auto p-4 bg-white border border-[#e5e5e5]"
              src="/images/talclogo.jpg"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-[#c99b36] font-bold text-4xl mb-6 block">Sobre Nós</h2>
          
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
             A TALC Assessoria Contábil oferece soluções contábeis completas para empresas de todos os portes em Santo Ângelo e região, unindo proximidade, estratégia e tecnologia.

            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
            Atuamos com organização, tecnologia aplicada e proximidade no atendimento para transformar a contabilidade em uma aliada da gestão e do crescimento do seu negócio.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="text-center group hover:bg-gray-50 p-6 rounded-xl transition-colors duration-300"
            >
              <div 
                className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center transition-transform group-hover:scale-110 duration-300"
                style={{ backgroundColor: `${value.color}15` }}
              >
                <value.icon size={40} style={{ color: value.color }} />
              </div>
              <h3 className="text-2xl font-bold text-[#0a4b3c] mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;